function _regeneratorValues(e) { if (null != e) { var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0; if (t) return t.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) return { next: function next() { return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e }; } }; } throw new TypeError(_typeof(e) + " is not iterable"); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as orderListApi from '@/api/orderListApi.js';
export default {
  name: 'DownloadTaskList',
  data: function data() {
    return {
      // 筛选表单
      filterForm: {
        status: '',
        taskType: '',
        taskName: ''
      },
      // 日期范围
      dateRange: [],
      // 任务列表
      taskList: [],
      // 选中任务
      selectedTasks: [],
      // 列表加载状态
      listLoading: false,
      // 清理过期任务加载状态
      cleaningLoading: false,
      // 管理员中止所有任务加载状态
      adminStopAllLoading: false,
      // 排队详情卡片
      showQueueDetailCard: true,
      queueTaskType: 'FAST_ORDER_EXPORT',
      currentQueueInfo: {
        hasProcessing: false,
        processingTasks: [],
        processingTask: null,
        waitingCount: 0,
        waitingTasks: [],
        userMaxQueuePosition: 0
      },
      // 分页信息
      pagination: {
        page: 1,
        limit: 20,
        total: 0
      },
      // 统计数据
      statistics: {
        pending: 0,
        processing: 0,
        completed: 0,
        failed: 0,
        cancelled: 0
      },
      // 通知状态
      notification: {
        show: false,
        type: 'success',
        title: '',
        message: ''
      },
      // 状态选项
      statusOptions: [{
        value: 'PENDING',
        label: '等待处理'
      }, {
        value: 'WAITING',
        label: '排队中'
      }, {
        value: 'PROCESSING',
        label: '处理中'
      }, {
        value: 'COMPLETED',
        label: '已完成'
      }, {
        value: 'FAILED',
        label: '失败'
      }, {
        value: 'CANCELLED',
        label: '已中止'
      }],
      // 任务类型选项
      taskTypeOptions: [{
        value: 'ORDER_EXPORT',
        label: '结果导出'
      }, {
        value: 'SUPPLIER_ORDER_EXPORT',
        label: '供应商订单导出'
      }, {
        value: 'FINANCE_EXPORT',
        label: '财务导出'
      }, {
        value: 'ENHANCED_ORDER_EXPORT',
        label: '快速导出'
      }, {
        value: 'FAST_ORDER_EXPORT',
        label: '订单导出'
      }, {
        value: 'OFFLINE_ORDER_EXPORT',
        label: '线下订单导出'
      }, {
        value: 'CUSTOMER_INTEGRAL_LOG_EXPORT',
        label: '积分日志导出'
      }, {
        value: 'CUSTOMER_INTEGRAL_LOG_DETAIL_EXPORT',
        label: '积分日志明细导出'
      }],
      // 进度条颜色
      progressColors: [{
        color: '#f56c6c',
        percentage: 20
      }, {
        color: '#e6a23c',
        percentage: 40
      }, {
        color: '#5cb87a',
        percentage: 60
      }, {
        color: '#1989fa',
        percentage: 80
      }, {
        color: '#67c23a',
        percentage: 100
      }],
      // 轮询定时器
      pollingTimer: null
    };
  },
  computed: {
    userType: function userType() {
      try {
        var javaInfo = JSON.parse(this.$cookies.get('JavaInfo') || '{}');
        return javaInfo.type;
      } catch (_unused) {
        return null;
      }
    },
    isAdmin: function isAdmin() {
      return this.userType === 1;
    },
    // 统计数据卡片
    statisticsCards: function statisticsCards() {
      return [{
        type: 'pending',
        label: '等待处理',
        icon: 'el-icon-time',
        count: this.statistics.pending,
        filterStatus: 'PENDING'
      }, {
        type: 'processing',
        label: '进行中',
        icon: 'el-icon-loading',
        count: this.statistics.processing,
        filterStatus: 'PROCESSING,WAITING' // 包含处理中和排队中
      }, {
        type: 'completed',
        label: '已完成',
        icon: 'el-icon-circle-check',
        count: this.statistics.completed,
        filterStatus: 'COMPLETED'
      }, {
        type: 'failed',
        label: '失败',
        icon: 'el-icon-circle-close',
        count: this.statistics.failed,
        filterStatus: 'FAILED'
      }, {
        type: 'cancelled',
        label: '已中止',
        icon: 'el-icon-video-pause',
        count: this.statistics.cancelled,
        filterStatus: 'CANCELLED'
      }];
    }
  },
  created: function created() {
    var _this = this;
    this.fetchTaskList().then(function () {
      _this.fetchStatistics();
      _this.fetchQueueDetail();
      _this.startPolling();
    });
  },
  mounted: function mounted() {
    // 键盘快捷键
    document.addEventListener('keydown', this.handleKeyDown);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.pollingTimer) {
      clearInterval(this.pollingTimer);
      this.pollingTimer = null;
    }
    document.removeEventListener('keydown', this.handleKeyDown);
  },
  methods: {
    // 键盘快捷键处理
    handleKeyDown: function handleKeyDown(e) {
      // Ctrl+R 刷新
      if (e.ctrlKey && e.key === 'r') {
        e.preventDefault();
        this.refreshAll();
      }
      // Escape 关闭通知
      if (e.key === 'Escape' && this.notification.show) {
        this.notification.show = false;
      }
    },
    // 刷新所有数据
    refreshAll: function refreshAll() {
      this.fetchTaskList();
      this.fetchStatistics();
      this.fetchQueueDetail();
      this.$message.success('数据已刷新');
    },
    // 复制任务ID
    copyTaskId: function copyTaskId(taskId) {
      var _this2 = this;
      if (!taskId) return;
      navigator.clipboard.writeText(String(taskId)).then(function () {
        _this2.$message.success('任务ID已复制');
      }).catch(function () {
        _this2.$message.error('复制失败');
      });
    },
    // 前往导出页面
    goToExport: function goToExport() {
      this.$router.push('/orderList/order/lists');
    },
    // 显示通知
    showNotification: function showNotification(type, title, message) {
      var _this3 = this;
      this.notification = {
        show: true,
        type: type,
        title: title,
        message: message
      };
      // 5秒后自动关闭
      setTimeout(function () {
        _this3.notification.show = false;
      }, 5000);
    },
    /**
     * 获取任务列表
     */
    fetchTaskList: function () {
      var _fetchTaskList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var statusValue, params, res, taskList, total, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.listLoading = true;
              _context.p = 1;
              // 处理多个状态值（逗号分隔）
              statusValue = this.filterForm.status || undefined;
              if (statusValue && statusValue.includes(',')) {
                // 如果有多个状态，转换为数组
                statusValue = statusValue.split(',');
              }
              params = {
                page: this.pagination.page,
                limit: this.pagination.limit,
                status: statusValue,
                taskType: this.filterForm.taskType || undefined,
                taskName: this.filterForm.taskName || undefined,
                startTime: this.dateRange && this.dateRange.length > 0 ? this.dateRange[0] : undefined,
                endTime: this.dateRange && this.dateRange.length > 0 ? this.dateRange[1] : undefined
              };
              _context.n = 2;
              return orderListApi.getDownloadTaskList(params);
            case 2:
              res = _context.v;
              taskList = [];
              total = 0;
              if (res && Array.isArray(res.list)) {
                taskList = res.list || [];
                total = res.total || 0;
              } else if (Array.isArray(res)) {
                taskList = res;
                total = res.length;
              } else if (res && Array.isArray(res)) {
                taskList = res;
                total = res.length;
              }
              this.taskList = taskList || [];
              this.pagination.total = total || 0;
              this.updateStatistics();
              this.startPolling();
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              this.$message.error('获取任务列表失败：' + (_t.message || '未知错误'));
            case 4:
              _context.p = 4;
              this.listLoading = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function fetchTaskList() {
        return _fetchTaskList.apply(this, arguments);
      }
      return fetchTaskList;
    }(),
    /**
     * 获取统计数据
     */
    fetchStatistics: function () {
      var _fetchStatistics = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return orderListApi.getDownloadTaskStatistics();
            case 1:
              res = _context2.v;
              if (!(res && _typeof(res) === 'object' && !Array.isArray(res))) {
                _context2.n = 2;
                break;
              }
              this.statistics = {
                pending: res.pending || 0,
                processing: (res.processing || 0) + (res.waiting || 0),
                completed: res.completed || 0,
                failed: res.failed || 0,
                cancelled: res.cancelled || 0
              };
              _context2.n = 3;
              break;
            case 2:
              _context2.n = 3;
              return this.fetchStatisticsByList();
            case 3:
              _context2.n = 5;
              break;
            case 4:
              _context2.p = 4;
              _t2 = _context2.v;
              _context2.n = 5;
              return this.fetchStatisticsByList();
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 4]]);
      }));
      function fetchStatistics() {
        return _fetchStatistics.apply(this, arguments);
      }
      return fetchStatistics;
    }(),
    fetchStatisticsByList: function () {
      var _fetchStatisticsByList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var params, res, tasks, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              params = {
                page: 1,
                limit: 1000
              };
              _context3.n = 1;
              return orderListApi.getDownloadTaskList(params);
            case 1:
              res = _context3.v;
              tasks = [];
              if (res && Array.isArray(res.list)) {
                tasks = res.list || [];
              } else if (Array.isArray(res)) {
                tasks = res;
              }
              this.statistics = {
                pending: tasks.filter(function (t) {
                  return t.status === 'PENDING';
                }).length,
                processing: tasks.filter(function (t) {
                  return t.status === 'PROCESSING' || t.status === 'WAITING';
                }).length,
                completed: tasks.filter(function (t) {
                  return t.status === 'COMPLETED';
                }).length,
                failed: tasks.filter(function (t) {
                  return t.status === 'FAILED';
                }).length,
                cancelled: tasks.filter(function (t) {
                  return t.status === 'CANCELLED';
                }).length
              };
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              console.error('通过列表获取统计数据失败', _t3);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function fetchStatisticsByList() {
        return _fetchStatisticsByList.apply(this, arguments);
      }
      return fetchStatisticsByList;
    }(),
    updateStatistics: function updateStatistics() {
      var _this4 = this;
      this.statistics = {
        pending: 0,
        processing: 0,
        completed: 0,
        failed: 0,
        cancelled: 0
      };
      this.taskList.forEach(function (task) {
        if (task.status === 'PENDING') _this4.statistics.pending++;else if (task.status === 'WAITING') _this4.statistics.processing++;else if (task.status === 'PROCESSING') _this4.statistics.processing++;else if (task.status === 'COMPLETED') _this4.statistics.completed++;else if (task.status === 'FAILED') _this4.statistics.failed++;else if (task.status === 'CANCELLED') _this4.statistics.cancelled++;
      });
    },
    startPolling: function startPolling() {
      var _this5 = this;
      this.stopPolling();
      var hasProcessingTask = this.taskList.some(function (task) {
        return task.status === 'PROCESSING';
      });
      if (hasProcessingTask) {
        this.pollingTimer = setInterval(function () {
          _this5.autoRefreshActiveTasks();
        }, 5000);
      }
    },
    autoRefreshActiveTasks: function autoRefreshActiveTasks() {
      // 只有处理中的任务才轮询，已中止/完成/失败等终态任务不再调用接口
      var hasProcessingTask = this.taskList.some(function (task) {
        return task.status === 'PROCESSING';
      });
      if (!hasProcessingTask) {
        this.stopPolling();
        return;
      }
      this.fetchQueueDetail();
      this.refreshProcessingTasks();
    },
    stopPolling: function stopPolling() {
      if (this.pollingTimer) {
        clearInterval(this.pollingTimer);
        this.pollingTimer = null;
      }
    },
    refreshProcessingTasks: function () {
      var _refreshProcessingTasks = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _this6 = this;
        var processingTasks, _iterator, _step, _loop, _t5;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              processingTasks = this.taskList.filter(function (task) {
                return task.status === 'PROCESSING';
              });
              _iterator = _createForOfIteratorHelper(processingTasks);
              _context5.p = 1;
              _loop = /*#__PURE__*/_regenerator().m(function _loop() {
                var task, res, taskData, index, oldStatus, _t4;
                return _regenerator().w(function (_context4) {
                  while (1) switch (_context4.p = _context4.n) {
                    case 0:
                      task = _step.value;
                      _context4.p = 1;
                      _context4.n = 2;
                      return orderListApi.getDownloadTaskDetail(task.id);
                    case 2:
                      res = _context4.v;
                      // 兼容 { code, data } 包装格式
                      taskData = res && res.data ? res.data : res;
                      if (taskData && _typeof(taskData) === 'object') {
                        index = _this6.taskList.findIndex(function (t) {
                          return t.id === task.id;
                        });
                        if (index !== -1) {
                          oldStatus = _this6.taskList[index].status;
                          _this6.$set(_this6.taskList, index, _objectSpread(_objectSpread({}, _this6.taskList[index]), taskData));
                          if (taskData.status !== oldStatus) {
                            _this6.handleTaskStatusChange(taskData);
                          }
                        }
                      }
                      _context4.n = 4;
                      break;
                    case 3:
                      _context4.p = 3;
                      _t4 = _context4.v;
                      console.error("\u5237\u65B0\u4EFB\u52A1".concat(task.id, "\u72B6\u6001\u5931\u8D25"), _t4);
                    case 4:
                      return _context4.a(2);
                  }
                }, _loop, null, [[1, 3]]);
              });
              _iterator.s();
            case 2:
              if ((_step = _iterator.n()).done) {
                _context5.n = 4;
                break;
              }
              return _context5.d(_regeneratorValues(_loop()), 3);
            case 3:
              _context5.n = 2;
              break;
            case 4:
              _context5.n = 6;
              break;
            case 5:
              _context5.p = 5;
              _t5 = _context5.v;
              _iterator.e(_t5);
            case 6:
              _context5.p = 6;
              _iterator.f();
              return _context5.f(6);
            case 7:
              return _context5.a(2);
          }
        }, _callee4, this, [[1, 5, 6, 7]]);
      }));
      function refreshProcessingTasks() {
        return _refreshProcessingTasks.apply(this, arguments);
      }
      return refreshProcessingTasks;
    }(),
    handleTaskStatusChange: function handleTaskStatusChange(task) {
      // 任何状态变化都自动刷新页面数据
      this.fetchTaskList();
      this.fetchStatistics();
      this.fetchQueueDetail();
      if (task.status === 'COMPLETED') {
        this.showNotification('success', '任务完成', "\u4EFB\u52A1\u300C".concat(task.taskName, "\u300D\u5DF2\u5B8C\u6210\uFF0C\u53EF\u4EE5\u4E0B\u8F7D\u6587\u4EF6\u4E86"));
      } else if (task.status === 'FAILED') {
        this.showNotification('error', '任务失败', "\u4EFB\u52A1\u300C".concat(task.taskName, "\u300D\u6267\u884C\u5931\u8D25"));
      } else if (task.status === 'CANCELLED') {
        this.showNotification('warning', '任务已中止', "\u4EFB\u52A1\u300C".concat(task.taskName, "\u300D\u5DF2\u88AB\u4E2D\u6B62"));
      }
    },
    // 中止自己正在执行的任务
    handleStopTask: function () {
      var _handleStopTask = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(row) {
        var _this7 = this;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              this.$confirm("\u786E\u5B9A\u8981\u4E2D\u6B62\u5BFC\u51FA\u4EFB\u52A1\u300C".concat(row.taskName, "\u300D\u5417\uFF1F\u4E2D\u6B62\u540E\u5C06\u505C\u6B62\u5F53\u524D\u5BFC\u51FA\u64CD\u4F5C\u3002"), '提示', {
                confirmButtonText: '确定中止',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
                var index, res, _index, _t6;
                return _regenerator().w(function (_context6) {
                  while (1) switch (_context6.p = _context6.n) {
                    case 0:
                      _context6.p = 0;
                      index = _this7.taskList.findIndex(function (t) {
                        return t.id === row.id;
                      });
                      if (index !== -1) {
                        _this7.$set(_this7.taskList[index], 'stopping', true);
                      }
                      _context6.n = 1;
                      return orderListApi.stopExecutingTask(row.id);
                    case 1:
                      res = _context6.v;
                      if (res !== false && res !== null) {
                        _this7.$message.success('已发出中止指令，任务将自动停止');
                        // 立即更新本地任务状态并停止轮询，防止下一次定时器触发时仍看到PROCESSING状态
                        _this7.$nextTick(function () {
                          var idx = _this7.taskList.findIndex(function (t) {
                            return t.id === row.id;
                          });
                          if (idx !== -1) {
                            _this7.$set(_this7.taskList, idx, _objectSpread(_objectSpread({}, _this7.taskList[idx]), {}, {
                              status: 'CANCELLED',
                              statusName: '已中止',
                              stopping: false
                            }));
                          }
                          _this7.stopPolling(); // 立即停止轮询定时器，防止fetchTaskList异步返回前定时器就触发
                          _this7.fetchTaskList();
                          _this7.fetchStatistics();
                          _this7.fetchQueueDetail();
                        });
                      } else {
                        _this7.$message.error('中止失败');
                      }
                      _context6.n = 3;
                      break;
                    case 2:
                      _context6.p = 2;
                      _t6 = _context6.v;
                      _this7.$message.error('中止失败：' + (_t6.message || '未知错误'));
                    case 3:
                      _context6.p = 3;
                      _index = _this7.taskList.findIndex(function (t) {
                        return t.id === row.id;
                      });
                      if (_index !== -1) {
                        _this7.$set(_this7.taskList[_index], 'stopping', false);
                      }
                      return _context6.f(3);
                    case 4:
                      return _context6.a(2);
                  }
                }, _callee5, null, [[0, 2, 3, 4]]);
              }))).catch(function () {});
            case 1:
              return _context7.a(2);
          }
        }, _callee6, this);
      }));
      function handleStopTask(_x) {
        return _handleStopTask.apply(this, arguments);
      }
      return handleStopTask;
    }(),
    // 从队列详情卡片中中止任务（支持管理员中止所有，用户中止自己的）
    handleStopTaskFromQueue: function () {
      var _handleStopTaskFromQueue = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(task) {
        var _this8 = this;
        var taskName, ownerName, confirmMsg;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              taskName = task.taskTypeName || '导出任务';
              ownerName = task.userName || '其他用户';
              if (this.isAdmin && !task.isCurrentUser) {
                confirmMsg = "\u786E\u5B9A\u8981\u4E2D\u6B62\u7528\u6237\u300C".concat(ownerName, "\u300D\u7684").concat(taskName, "\u4EFB\u52A1\u5417\uFF1F\u4E2D\u6B62\u540E\u5C06\u505C\u6B62\u5F53\u524D\u5BFC\u51FA\u64CD\u4F5C\u3002");
              } else {
                confirmMsg = "\u786E\u5B9A\u8981\u4E2D\u6B62".concat(taskName, "\u4EFB\u52A1\u5417\uFF1F\u4E2D\u6B62\u540E\u5C06\u505C\u6B62\u5F53\u524D\u5BFC\u51FA\u64CD\u4F5C\u3002");
              }
              this.$confirm(confirmMsg, '提示', {
                confirmButtonText: '确定中止',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
                var res, _t7;
                return _regenerator().w(function (_context8) {
                  while (1) switch (_context8.p = _context8.n) {
                    case 0:
                      _context8.p = 0;
                      // 标记 loading 状态
                      _this8.$set(task, 'stopping', true);
                      _context8.n = 1;
                      return orderListApi.stopExecutingTask(task.taskId);
                    case 1:
                      res = _context8.v;
                      if (res !== false && res !== null) {
                        _this8.$message.success('已发出中止指令，任务将自动停止');
                        // 刷新队列详情
                        _this8.fetchQueueDetail();
                        _this8.fetchTaskList();
                        _this8.fetchStatistics();
                      } else {
                        _this8.$message.error('中止失败');
                      }
                      _context8.n = 3;
                      break;
                    case 2:
                      _context8.p = 2;
                      _t7 = _context8.v;
                      _this8.$message.error('中止失败：' + (_t7.message || '未知错误'));
                    case 3:
                      _context8.p = 3;
                      _this8.$set(task, 'stopping', false);
                      return _context8.f(3);
                    case 4:
                      return _context8.a(2);
                  }
                }, _callee7, null, [[0, 2, 3, 4]]);
              }))).catch(function () {});
            case 1:
              return _context9.a(2);
          }
        }, _callee8, this);
      }));
      function handleStopTaskFromQueue(_x2) {
        return _handleStopTaskFromQueue.apply(this, arguments);
      }
      return handleStopTaskFromQueue;
    }(),
    // 管理员中止所有执行中的任务
    handleAdminStopAll: function () {
      var _handleAdminStopAll = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var _this9 = this;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              this.$confirm('确定要中止所有用户正在执行的导出任务吗？此操作将影响所有用户。', '管理员操作警告', {
                confirmButtonText: '确定中止全部',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
                var res, _t8;
                return _regenerator().w(function (_context0) {
                  while (1) switch (_context0.p = _context0.n) {
                    case 0:
                      _this9.adminStopAllLoading = true;
                      _context0.p = 1;
                      _context0.n = 2;
                      return orderListApi.adminStopAllTasks();
                    case 2:
                      res = _context0.v;
                      if (res !== false && res !== null) {
                        _this9.$message.success('已中止 ' + res + ' 个执行中的任务');
                        _this9.stopPolling(); // 立即停止轮询定时器
                        _this9.fetchTaskList();
                        _this9.fetchStatistics();
                        _this9.fetchQueueDetail();
                      } else {
                        _this9.$message.error('操作失败');
                      }
                      _context0.n = 4;
                      break;
                    case 3:
                      _context0.p = 3;
                      _t8 = _context0.v;
                      _this9.$message.error('操作失败：' + (_t8.message || '未知错误'));
                    case 4:
                      _context0.p = 4;
                      _this9.adminStopAllLoading = false;
                      return _context0.f(4);
                    case 5:
                      return _context0.a(2);
                  }
                }, _callee9, null, [[1, 3, 4, 5]]);
              }))).catch(function () {});
            case 1:
              return _context1.a(2);
          }
        }, _callee0, this);
      }));
      function handleAdminStopAll() {
        return _handleAdminStopAll.apply(this, arguments);
      }
      return handleAdminStopAll;
    }(),
    handleRefreshStatus: function () {
      var _handleRefreshStatus = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(row) {
        var index, res, taskData, oldStatus, _index2, _t9;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.p = _context10.n) {
            case 0:
              _context10.p = 0;
              index = this.taskList.findIndex(function (t) {
                return t.id === row.id;
              });
              if (index !== -1) {
                this.$set(this.taskList[index], 'refreshing', true);
              }
              _context10.n = 1;
              return orderListApi.getDownloadTaskDetail(row.id);
            case 1:
              res = _context10.v;
              if (res && _typeof(res) === 'object') {
                // 兼容 { code, data } 包装格式
                taskData = res && res.data ? res.data : res;
                if (index !== -1) {
                  oldStatus = this.taskList[index].status;
                  this.$set(this.taskList, index, _objectSpread(_objectSpread({}, taskData), {}, {
                    refreshing: false
                  }));
                  if (taskData.status !== oldStatus) {
                    this.handleTaskStatusChange(taskData);
                  } else if (taskData.status === 'WAITING') {
                    this.$message.info('当前排队位置：第 ' + (taskData.queuePosition || '-') + ' 位');
                  }
                }
              } else {
                this.$message.warning('未获取到任务数据');
              }
              _context10.n = 3;
              break;
            case 2:
              _context10.p = 2;
              _t9 = _context10.v;
              this.$message.error('刷新任务状态失败：' + (_t9.message || '未知错误'));
            case 3:
              _context10.p = 3;
              _index2 = this.taskList.findIndex(function (t) {
                return t.id === row.id;
              });
              if (_index2 !== -1) {
                this.$set(this.taskList[_index2], 'refreshing', false);
              }
              return _context10.f(3);
            case 4:
              return _context10.a(2);
          }
        }, _callee1, this, [[0, 2, 3, 4]]);
      }));
      function handleRefreshStatus(_x3) {
        return _handleRefreshStatus.apply(this, arguments);
      }
      return handleRefreshStatus;
    }(),
    handleDownload: function handleDownload(row) {
      if (!row.filePath) {
        this.$message.error('文件路径不存在');
        return;
      }
      try {
        orderListApi.downloadFileByPath(row.filePath, row.fileName);
        this.$message.success('开始下载文件：' + row.fileName);
      } catch (error) {
        this.$message.error('下载文件失败：' + (error.message || '未知错误'));
      }
    },
    handleDelete: function handleDelete(row) {
      var _this0 = this;
      orderListApi.deleteDownloadTask(row.id).then(function (res) {
        if (res !== false && res !== null) {
          _this0.$message.success('删除成功');
          _this0.fetchTaskList();
          _this0.fetchStatistics();
        } else {
          _this0.$message.error('删除失败');
        }
      }).catch(function (error) {
        _this0.$message.error('删除失败：' + (error.message || '未知错误'));
      });
    },
    handleCancelQueue: function handleCancelQueue(row) {
      var _this1 = this;
      this.$confirm("\u786E\u5B9A\u8981\u53D6\u6D88\u6392\u961F\u4EFB\u52A1\u300C".concat(row.taskName, "\u300D\u5417\uFF1F\u53D6\u6D88\u540E\u5C06\u81EA\u52A8\u89E6\u53D1\u4E0B\u4E00\u4E2A\u6392\u961F\u4EFB\u52A1\u3002"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
        var res, _t0;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.p = _context11.n) {
            case 0:
              _context11.p = 0;
              _context11.n = 1;
              return orderListApi.cancelQueuedTask(row.id);
            case 1:
              res = _context11.v;
              if (res !== false && res !== null) {
                _this1.$message.success('已取消排队任务');
                _this1.stopPolling(); // 立即停止轮询定时器
                _this1.fetchTaskList();
                _this1.fetchStatistics();
                _this1.fetchQueueDetail();
              } else {
                _this1.$message.error('取消失败');
              }
              _context11.n = 3;
              break;
            case 2:
              _context11.p = 2;
              _t0 = _context11.v;
              _this1.$message.error('取消失败：' + (_t0.message || '未知错误'));
            case 3:
              return _context11.a(2);
          }
        }, _callee10, null, [[0, 2]]);
      }))).catch(function () {});
    },
    handleBatchDelete: function handleBatchDelete() {
      var _this10 = this;
      if (this.selectedTasks.length === 0) {
        this.$message.warning('请先选择要删除的任务');
        return;
      }
      this.$confirm("\u786E\u5B9A\u8981\u5220\u9664\u9009\u4E2D\u7684 ".concat(this.selectedTasks.length, " \u4E2A\u4EFB\u52A1\u5417\uFF1F"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11() {
        var successCount, failCount, _iterator2, _step2, task, res, _t1, _t10;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.p = _context12.n) {
            case 0:
              successCount = 0;
              failCount = 0;
              _iterator2 = _createForOfIteratorHelper(_this10.selectedTasks);
              _context12.p = 1;
              _iterator2.s();
            case 2:
              if ((_step2 = _iterator2.n()).done) {
                _context12.n = 7;
                break;
              }
              task = _step2.value;
              _context12.p = 3;
              _context12.n = 4;
              return orderListApi.deleteDownloadTask(task.id);
            case 4:
              res = _context12.v;
              if (res !== false && res !== null) {
                successCount++;
              } else {
                failCount++;
              }
              _context12.n = 6;
              break;
            case 5:
              _context12.p = 5;
              _t1 = _context12.v;
              failCount++;
            case 6:
              _context12.n = 2;
              break;
            case 7:
              _context12.n = 9;
              break;
            case 8:
              _context12.p = 8;
              _t10 = _context12.v;
              _iterator2.e(_t10);
            case 9:
              _context12.p = 9;
              _iterator2.f();
              return _context12.f(9);
            case 10:
              if (failCount === 0) {
                _this10.$message.success("\u6210\u529F\u5220\u9664 ".concat(successCount, " \u4E2A\u4EFB\u52A1"));
              } else {
                _this10.$message.warning("\u6210\u529F ".concat(successCount, " \u4E2A\uFF0C\u5931\u8D25 ").concat(failCount, " \u4E2A"));
              }
              _this10.selectedTasks = [];
              _this10.fetchTaskList();
              _this10.fetchStatistics();
            case 11:
              return _context12.a(2);
          }
        }, _callee11, null, [[3, 5], [1, 8, 9, 10]]);
      }))).catch(function () {});
    },
    handleCleanExpired: function () {
      var _handleCleanExpired = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13() {
        var _this11 = this;
        return _regenerator().w(function (_context14) {
          while (1) switch (_context14.n) {
            case 0:
              this.$confirm('确定要清理所有已过期的任务吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12() {
                var res, _t11;
                return _regenerator().w(function (_context13) {
                  while (1) switch (_context13.p = _context13.n) {
                    case 0:
                      _this11.cleaningLoading = true;
                      _context13.p = 1;
                      _context13.n = 2;
                      return orderListApi.batchDeleteExpiredTasks();
                    case 2:
                      res = _context13.v;
                      if (res !== false && res !== null) {
                        _this11.$message.success("\u5DF2\u6E05\u7406 ".concat(res, " \u4E2A\u8FC7\u671F\u4EFB\u52A1"));
                        _this11.fetchTaskList();
                        _this11.fetchStatistics();
                      } else {
                        _this11.$message.error('清理失败');
                      }
                      _context13.n = 4;
                      break;
                    case 3:
                      _context13.p = 3;
                      _t11 = _context13.v;
                      _this11.$message.error('清理失败：' + (_t11.message || '未知错误'));
                    case 4:
                      _context13.p = 4;
                      _this11.cleaningLoading = false;
                      return _context13.f(4);
                    case 5:
                      return _context13.a(2);
                  }
                }, _callee12, null, [[1, 3, 4, 5]]);
              }))).catch(function () {});
            case 1:
              return _context14.a(2);
          }
        }, _callee13, this);
      }));
      function handleCleanExpired() {
        return _handleCleanExpired.apply(this, arguments);
      }
      return handleCleanExpired;
    }(),
    handleFilterChange: function handleFilterChange() {
      this.pagination.page = 1;
      this.fetchTaskList();
    },
    handleDateRangeChange: function handleDateRangeChange(val) {
      this.handleFilterChange();
    },
    handleReset: function handleReset() {
      this.filterForm = {
        status: '',
        taskType: '',
        taskName: ''
      };
      this.dateRange = [];
      this.pagination.page = 1;
      this.fetchTaskList();
    },
    handleStatusFilter: function handleStatusFilter(status) {
      if (this.filterForm.status === status) {
        this.filterForm.status = '';
      } else {
        this.filterForm.status = status;
      }
      this.handleFilterChange();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.selectedTasks = val;
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pagination.limit = val;
      this.pagination.page = 1;
      this.fetchTaskList();
    },
    handlePageChange: function handlePageChange(val) {
      this.pagination.page = val;
      this.fetchTaskList();
    },
    tableRowClassName: function tableRowClassName(_ref7) {
      var row = _ref7.row;
      if (row.status === 'PROCESSING') return 'processing-row';else if (row.status === 'WAITING') return 'waiting-row';else if (row.status === 'FAILED') return 'failed-row';else if (row.status === 'CANCELLED') return 'cancelled-row';
      return '';
    },
    getStatusTagType: function getStatusTagType(status) {
      var typeMap = {
        'PENDING': 'info',
        'WAITING': 'warning',
        'PROCESSING': 'primary',
        'COMPLETED': 'success',
        'FAILED': 'danger',
        'CANCELLED': 'warning'
      };
      return typeMap[status] || 'info';
    },
    formatDateTime: function formatDateTime(dateTime) {
      if (!dateTime) return '-';
      var date = new Date(dateTime);
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, '0');
      var day = String(date.getDate()).padStart(2, '0');
      var hours = String(date.getHours()).padStart(2, '0');
      var minutes = String(date.getMinutes()).padStart(2, '0');
      var seconds = String(date.getSeconds()).padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
    },
    formatDuration: function formatDuration(seconds) {
      if (!seconds) return '-';
      if (seconds < 60) return "".concat(seconds, "\u79D2");
      if (seconds < 3600) {
        var _minutes = Math.floor(seconds / 60);
        var secs = seconds % 60;
        return "".concat(_minutes, "\u5206").concat(secs, "\u79D2");
      }
      var hours = Math.floor(seconds / 3600);
      var minutes = Math.floor(seconds % 3600 / 60);
      return "".concat(hours, "\u65F6").concat(minutes, "\u5206");
    },
    formatExpireTime: function formatExpireTime(expireTime) {
      if (!expireTime) return '-';
      var now = new Date();
      var expire = new Date(expireTime);
      var diff = expire - now;
      if (diff <= 0) return '已过期';
      var hours = Math.floor(diff / (1000 * 60 * 60));
      var minutes = Math.floor(diff % (1000 * 60 * 60) / (1000 * 60));
      if (hours > 24) {
        var days = Math.floor(hours / 24);
        return "".concat(days, "\u5929");
      }
      if (hours > 0) return "".concat(hours, "\u5C0F\u65F6");
      return "".concat(minutes, "\u5206\u949F");
    },
    isExpireSoon: function isExpireSoon(expireTime) {
      if (!expireTime) return false;
      var now = new Date();
      var expire = new Date(expireTime);
      var diff = expire - now;
      return diff > 0 && diff < 6 * 60 * 60 * 1000;
    },
    isExpireWarning: function isExpireWarning(expireTime) {
      if (!expireTime) return false;
      var now = new Date();
      var expire = new Date(expireTime);
      var diff = expire - now;
      return diff > 0 && diff < 24 * 60 * 60 * 1000;
    },
    fetchQueueDetail: function () {
      var _fetchQueueDetail = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14() {
        var res, _t12;
        return _regenerator().w(function (_context15) {
          while (1) switch (_context15.p = _context15.n) {
            case 0:
              _context15.p = 0;
              _context15.n = 1;
              return orderListApi.getDownloadQueueDetail(this.queueTaskType);
            case 1:
              res = _context15.v;
              if (res && _typeof(res) === 'object' && !Array.isArray(res)) {
                this.currentQueueInfo = {
                  hasProcessing: res.hasProcessing,
                  processingTasks: res.processingTasks || [],
                  processingTask: res.processingTask || null,
                  waitingCount: res.waitingCount,
                  waitingTasks: res.waitingTasks || [],
                  userMaxQueuePosition: res.userMaxQueuePosition
                };
              }
              _context15.n = 3;
              break;
            case 2:
              _context15.p = 2;
              _t12 = _context15.v;
              console.error('获取排队详情失败:', _t12);
            case 3:
              return _context15.a(2);
          }
        }, _callee14, this, [[0, 2]]);
      }));
      function fetchQueueDetail() {
        return _fetchQueueDetail.apply(this, arguments);
      }
      return fetchQueueDetail;
    }(),
    handleQueueTypeChange: function handleQueueTypeChange(tab) {
      this.queueTaskType = tab.name;
      this.fetchQueueDetail();
    },
    formatWaitTime: function formatWaitTime(seconds) {
      if (!seconds || seconds <= 0) return '即将开始';
      if (seconds < 60) return "".concat(seconds, "\u79D2");
      if (seconds < 3600) return "".concat(Math.floor(seconds / 60), "\u5206\u949F");
      return "".concat(Math.floor(seconds / 3600), "\u5C0F\u65F6").concat(Math.floor(seconds % 3600 / 60), "\u5206\u949F");
    },
    formatTaskId: function formatTaskId(taskId) {
      if (!taskId) return '-';
      var str = String(taskId);
      if (str.length <= 4) return str;
      return '...' + str.slice(-4);
    },
    formatDisplayTime: function formatDisplayTime(timeStr) {
      if (!timeStr) return '-';
      try {
        var date = new Date(timeStr);
        var month = String(date.getMonth() + 1).padStart(2, '0');
        var day = String(date.getDate()).padStart(2, '0');
        var hours = String(date.getHours()).padStart(2, '0');
        var minutes = String(date.getMinutes()).padStart(2, '0');
        var seconds = String(date.getSeconds()).padStart(2, '0');
        return "".concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
      } catch (e) {
        return timeStr;
      }
    }
  }
};